import { IWatrTrip } from '@nkr/models/watr-trip';

export const TRIP_PHASE_ORDER: { [key: number]: number } = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 1
};

export const PHASE_NAME_ORDER: { [key: string]: number } = {
    'Work-Up': 1,
    'Post Work-Up': 2,
    'Lab Test': 3,
    'Pre-Op': 4,
    'Surgery': 5,
    'Post-Op': 6,
    'Other': 7,
    'International Workup': 1
};

const TRIP_REASON_MAP: { [key: number]: string } = {
    1: 'Work-Up',
    2: 'Post Work-Up',
    3: 'Lab Test',
    4: 'Pre-Op',
    5: 'Surgery',
    6: 'Post-Op',
    7: 'Other',
    8: 'International Workup'
};

export const getTripPhaseName = (trip: IWatrTrip): string => {
    if (trip.tripReasonId && TRIP_REASON_MAP[trip.tripReasonId]) {
        return TRIP_REASON_MAP[trip.tripReasonId];
    }
    
    if (trip.tripReason && trip.tripReason.trim() !== '') {
        return trip.tripReason;
    }
    
    return 'Trip Reason';
};

export const getTripPhaseOrder = (trip: IWatrTrip): number => {
    if (trip.tripReasonId && TRIP_PHASE_ORDER[trip.tripReasonId]) {
        return TRIP_PHASE_ORDER[trip.tripReasonId];
    }
    
    const phaseName = getTripPhaseName(trip);
    if (PHASE_NAME_ORDER[phaseName]) {
        return PHASE_NAME_ORDER[phaseName];
    }
    
    return 999;
};

